<template>
  <div>
    <div class="col-md-12">
      <form name="newDocument" @submit.prevent="handleSubmit()">
        <div class="modal-body">
          <label>Subject :</label>

          <input
            name="Subject"
            v-validate="'required'"
            v-model="encodingData.Subject"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('Subject') }"
          />

          <span
            v-if="submitted && errors.has('Subject')"
            class="invalid-feedback"
            >{{ errors.first("Subject") }}</span
          >

          <label>Date Started :</label>

          <input
            type="date"
            name="DateStart"
            v-validate="'required'"
            v-model="encodingData.DateStart"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('DateStart') }"
          />

          <span
            v-if="submitted && errors.has('DateStart')"
            class="invalid-feedback"
            >{{ errors.first("DateStart") }}</span
          >

          <label>Date End :</label>

          <input
            type="date"
            name="DateEnd"
            v-validate="'required'"
            v-model="encodingData.DateEnd"
            class="form-control"
          />

          <span
            v-if="submitted && errors.has('DateEnd')"
            class="invalid-feedback"
            >{{ errors.first("DateEnd") }}</span
          >

          <label>Time Start :</label>

          <input
            type="time"
            name="TimeStart"
            v-model="encodingData.TimeStart"
            class="form-control"
          />

          <label>Time End :</label>

          <input
            type="time"
            name="TimeEnd"
            v-model="encodingData.TimeEnd"
            class="form-control"
          />

          <label>Event Type:</label>

          <select name="Type" v-model="encodingData.Type" class="form-control">
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.eventType"
              v-bind:key="option.eventType"
            >
              {{ option.eventType }}
            </option>
          </select>

          <label>Latitude :</label>

          <input
            type="text"
            name="Gpslat"
            v-model="encodingData.Gpslat"
            class="form-control"
          />

          <label>Longitude :</label>

          <input
            type="text"
            name="Gpslon"
            v-model="encodingData.Gpslon"
            class="form-control"
          />

          <label>Country:</label>

          <select name v-model="encodingData.Country" class="form-control">
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>

          <label>Region:</label>

          <select name v-model="encodingData.Region" class="form-control">
            <option value>Select Region</option>
            <option
              v-for="option in regions"
              v-bind:value="option.region"
              v-bind:key="option.region"
            >
              {{ option.region }}
            </option>
          </select>

          <label>State:</label>

          <select name v-model="encodingData.State" class="form-control">
            <option value>Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>

          <label>City :</label>

          <input
            type="text"
            name="City"
            v-model="encodingData.City"
            class="form-control"
          />

          <label>Wounded :</label>

          <input
            type="number"
            name="Wounded"
            v-model="encodingData.Wounded"
            class="form-control"
          />

          <label>Killed :</label>

          <input
            type="number"
            name="Killed"
            v-model="encodingData.Killed"
            class="form-control"
          />

          <label>Comments :</label>

          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />

          <label>Status :</label>

          <textarea
            name="EvStatus"
            v-model="encodingData.EvStatus"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageEventType,
  getlocalstorageEventRegion,
  formatdate,
} from "../../helper";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        EventId: "",
        Subject: "",
        DateStart: "",
        DateEnd: null,
        TimeStart: null,
        TimeEnd: null,
        Type: "",
        Gpslat: null,
        Gpslon: null,
        Country: "",
        Region: "",
        State: "",
        City: "",
        Wounded: 0,
        Killed: 0,
        Comments: "",
        EvStatus: "",
      },
      countries: [],
      provinces: [],
      types: [],
      regions: [],
      submitted: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstorageEventType();
      this.regions = getlocalstorageEventRegion();
      this.getEvent();
    },
    getEvent() {
      instance
        .get(DataURL + "events?eventID=" + this.id, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data;
              this.encodingData.EventId = data.eventId;
              this.encodingData.Subject = data.subject;
              this.encodingData.DateStart = formatdate(data.dateStart);
              this.encodingData.DateEnd =
                data.dateEnd == null ? "" : formatdate(data.dateEnd);
              this.encodingData.TimeStart = data.timeStart;
              this.encodingData.TimeEnd = data.timeEnd;
              this.encodingData.Type = data.type;
              this.encodingData.Gpslat = data.gpslat;
              this.encodingData.Gpslon = data.gpslon;
              this.encodingData.Country = data.country;
              this.encodingData.Region = data.region;
              this.encodingData.State = data.state;
              this.encodingData.City = data.city;
              this.encodingData.Wounded = data.wounded;
              this.encodingData.Killed = data.killed;
              this.encodingData.Comments = data.comments;
              this.encodingData.EvStatus = data.evStatus;
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        });
    },
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          instance
            .post(EncodeURL + "updateEvent", this.encodingData, {
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                loader.hide();
                notifyHelper("error", response.data.message);
              } else {
                loader.hide();
                notifyHelper("success", response.data.message);
                this.$emit("done-edit-event");
              }
            })
            .catch(function (error) {
              responseCheck(error.response.status);
            });
        }
      });
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>
